export async function logoExists() {
  try {
    const res = await fetch('/company/logo.webp', { method: 'GET' })
    return res.ok
  } catch {
    return false
  }
}
